import React, { lazy } from 'react';
import { Route, useLocation } from 'react-router-dom';

const BoardListPage = lazy(() => import('@/pages/board/BoardListPage'));
const BoardViewPage = lazy(() => import('@/pages/board/BoardViewPage'));
const BoardWritePage = lazy(() => import('@/pages/board/BoardWritePage'));
const BoardEditPage = lazy(() => import('@/pages/board/BoardEditPage'));

/**
 * 게시판 종류(:type)가 바뀌어도 같은 컴포넌트가 재사용되므로
 * key 를 주입해 강제로 다시 마운트시킨다.
 */
const BoardListPageWithKey = () => {
  const location = useLocation();
  return <BoardListPage key={location.pathname} />;
};

/** 게시판 모듈 라우트 — 게시판은 별도 메뉴 권한 가드를 두지 않는다(기존 동작 유지) */
const boardRoutes = [
  <Route key="board-list" path="board/:type" element={<BoardListPageWithKey />} />,
  <Route key="board-write" path="board/:type/write" element={<BoardWritePage />} />,
  <Route key="board-view" path="board/:type/view/:id" element={<BoardViewPage />} />,
  <Route key="board-edit" path="board/:type/edit/:id" element={<BoardEditPage />} />,
];

export default boardRoutes;
